export default {
  /* Nút bấm */
  bt: {
    export: "Xuất (Tối đa 500 dòng mỗi lần)",
    createSingleDraft: "Tạo bản nháp đơn",
    batchAdd: "Thêm hàng loạt",
    editEmailTemplate: "Chỉnh sửa mẫu email",
    cancel: "Hủy",
    confirmAdd: "Thêm",
    retry: "Thử lại",
    saveSettings: "Lưu cài đặt",
    saving: "Đang lưu..."
  },
  /* Trường chung hoặc trường hàm tiện ích */
  common: {
    businessType: "Loại hình kinh doanh",
    businessTypePlaceholder: "Chọn loại hình kinh doanh",
    queryTime: "Thời gian truy vấn",
    businessTypeGM: "GM",
    businessTypeCX: "CX",
    businessTypeGMCX: "GMCX",
    sequence: "STT",
    startTime:"Thời gian bắt đầu",
    endTime:"Thời gian kết thúc",
    creator:"Người tạo",
    updater:"Người cập nhật",
    createTime:"Thời gian tạo",
    updateTime:"Thời gian cập nhật",
    phone:"Điện thoại",
    email:"E-mail",
    idNumber:"Số CMND",
    status:"Trạng thái",
    remark:"Ghi chú"
  },
  /* Tin nhắn và mẹo phổ biến */
  msg: {
    apiError: "(Mã trạng thái {status}) {message}",
    networkError: "Không thể kết nối đến máy chủ, vui lòng kiểm tra kết nối mạng của bạn.",
    unknownError: "Đã xảy ra lỗi không xác định.",
    resetSuccess: "Tất cả các trường và bộ lọc đã được đặt lại."
  },
  listCommon: {
    pno: "PNO",
    pnoPlaceholder: "Nhập một hoặc nhiều PNO, cách nhau bằng ',' hoặc ', '",
    templateType: "Loại mẫu (để thêm đơn)",
    templateTypePlaceholder: "Vui lòng chọn",
    accountNo: "Số tài khoản",
    proposalNo: "Số đề xuất",
    paidAmount: "Số tiền đã thanh toán",
    gatewayName: "Tên cổng thanh toán",
    name: "Tên",
    currency: "Tiền tệ",
    emailSentTime: "Thời gian gửi email",
    proposalStatus: "Trạng thái đề xuất",
    lastUpdateTime: "Thời gian cập nhật cuối",
    depositDiscrepancyProcessTime: "Thời gian xử lý chênh lệch"
  },
  listMsg: {
    pnoRequiredForSingle: "Trường PNO không được để trống khi tạo một bản nháp đơn.",
    pnoRequiredForBatch: "Trường PNO không được để trống khi thêm hàng loạt.",
    pnoBatchLimit: "Số lượng PNO để thêm hàng loạt không được vượt quá 50.",
    batchAddConfirmTitle: "Xác nhận thêm hàng loạt",
    classifying: "Đang phân loại, vui lòng chờ...",
    gmPnos: "PNO loại GM",
    cxPnos: "PNO loại CX",
    invalidPnos: "Các PNO sau không hợp lệ, đã tồn tại, đã hủy hoặc đã được phê duyệt và sẽ không được sử dụng để tạo bản nháp",
    invalidPnoError: "PNO không hợp lệ, đã tồn tại, đã bị hủy hoặc đã được phê duyệt!!!",
    getTemplateFailed: "Không thể lấy mẫu email đã điền.",
    classifyFailed: "Phân loại thất bại: {error}",
    getTemplateError: "Lỗi khi lấy mẫu {templateType}: {error}",
    extensionAPIError: "Không phát hiện thấy API giao tiếp của tiện ích mở rộng Google Chrome.",
    extensionIdError: "ID tiện ích mở rộng Google Chrome không hợp lệ",
    extensionCommError: "Không thể giao tiếp với tiện ích mở rộng: {message}",
    extensionOpError: "Thao tác tiện ích mở rộng thất bại: {error}",
    extensionSuccess: "Yêu cầu đã được gửi đến tiện ích mở rộng!",
    extensionOpSuccess: "Tiện ích mở rộng đã thực hiện thành công hành động: {action}",
    extensionOnlyMessage: "Tính năng này chỉ khả dụng trong trình duyệt Google Chrome và khi tiện ích mở rộng tương ứng đã được cài đặt.",
    exportListTitle: "Danh sách gửi email chênh lệch tiền gửi",
    editEmailTemplateTitle: "Chỉnh sửa Mẫu Email",
    loadingTemplate: "Đang tải mẫu...",
    loadTemplateFailed: "Tải mẫu thất bại:",
    templateInfoPart1: "Khi tạo bản nháp, các mẫu sau sẽ được sử dụng để tự động điền. Bạn có thể sử dụng",
    templateInfoPart2: "làm chỗ заполнителя.",
    templateSectionGM: "Mẫu loại GM",
    templateSectionCX: "Mẫu loại CX",
    recipientTemplate: "Mẫu người nhận ({type}):",
    subjectTemplate: "Mẫu chủ đề ({type}):",
    bodyTemplate: "Mẫu nội dung ({type}):",
    recipientPlaceholder: "Ví dụ: {example}",
    subjectPlaceholderGM: "Ví dụ: Chênh lệch tiền gửi GM - PNO: {pno}",
    subjectPlaceholderCX: "Ví dụ: Chênh lệch tiền gửi CX - PNO: {pno}",
    bodyPlaceholderGM: "Mẫu nội dung liên quan đến GM...",
    bodyPlaceholderCX: "Mẫu nội dung liên quan đến CX...",
    saveSuccess: "Mẫu email đã được cập nhật thành công!",
    saveError: "Lưu thất bại: {error}"
  },
  statsCommon: {
    statsDate: "Ngày",
    statsSize: "Số lượng",
    statsSmallAmountTransfer: "Chuyển khoản số tiền nhỏ: dưới 10.000 Nhân dân tệ",
    statsLargeAmountTransfer: "Chuyển khoản số tiền lớn: trên 10.000 Nhân dân tệ",
    statsAlipay: "Alipay",
    statsUSDT: "USDT",
    statsDigitalRMB: "Nhân dân tệ kỹ thuật số",
    statsCloudQuickPass: "Cloud Quick Pass",
    statsCardCode: "Mã thẻ",
    statsWeChat: "WeChat",
    statsYunPayTransfer: "Chuyển khoản YunPay",
    statsOthers: "Khác",
    statsDiscrepancyAmountCNY: "Số tiền chênh lệch CNY",
    statsDiscrepancyAmountUSD: "Số tiền chênh lệch USD",
    statsDiscrepancyAmountOthers: "Số tiền chênh lệch (Khác)",
    statsTotalProcessingTime: "Tổng thời gian xử lý",
    statsAverageProcessingTime: "Thời gian xử lý trung bình"
  },
  statsMsg: {
    exportListTitle: "Thống kê chênh lệch"
  }
};
